import React from 'react';
import { useTranslation } from 'react-i18next';

const releases = [
  {
    version: '1.1.2',
    date: '2025-10-08',
    items: [
      'changelog.items.112_1',
      'changelog.items.112_2',
      'changelog.items.112_3',
    ],
  },
  {
    version: '1.1.1',
    date: '2025-09-28',
    items: [
      'changelog.items.111_1',
      'changelog.items.111_2',
    ],
  },
  {
    version: '1.1.0',
    date: '2025-09-01',
    items: [
      'changelog.items.110_1',
      'changelog.items.110_2',
    ],
  },
];

export default function Changelog() {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('changelog.title')}</h1>
      <p className="text-sm text-gray-500 mb-8">{t('changelog.subtitle')}</p>

      <div className="space-y-8">
        {releases.map(rel => (
          <section key={rel.version}>
            <header className="mb-2">
              <h2 className="text-xl font-semibold">
                {t('changelog.version', { version: rel.version })}{' '}
                <span className="text-sm text-gray-500">({rel.date})</span>
              </h2>
            </header>
            <ul className="list-disc list-inside space-y-1">
              {rel.items.map(k => (
                <li key={k}>{t(k)}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
